var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.name,
            expression: "rules.name"
          }
        ],
        attrs: {
          label: "Name",
          name: "Name",
          placeholder: "Valid zone name",
          "error-messages": _vm.errors.collect("Name")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.name,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.ttl,
            expression: "rules.ttl"
          }
        ],
        attrs: {
          label: "TTL",
          name: "TTL",
          placeholder: "14400",
          "error-messages": _vm.errors.collect("TTL")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.ttl,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "ttl", $$v)
          },
          expression: "model.ttl"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.priority,
            expression: "rules.priority"
          }
        ],
        attrs: {
          label: "Priority",
          name: "Priority",
          type: "number",
          placeholder: "Integer",
          "error-messages": _vm.errors.collect("Priority")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.priority,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "priority", $$v)
          },
          expression: "model.priority"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.weight,
            expression: "rules.weight"
          }
        ],
        attrs: {
          label: "Weight",
          name: "Weight",
          type: "number",
          placeholder: "Integer",
          "error-messages": _vm.errors.collect("Weight")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.weight,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "weight", $$v)
          },
          expression: "model.weight"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.port,
            expression: "rules.port"
          }
        ],
        attrs: {
          label: "Port",
          name: "Port",
          type: "number",
          placeholder: "Port number",
          "error-messages": _vm.errors.collect("Port")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.port,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "port", $$v)
          },
          expression: "model.port"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.url,
            expression: "rules.url"
          }
        ],
        attrs: {
          label: "Target",
          name: "Target",
          placeholder: "Valid zone name",
          "error-messages": _vm.errors.collect("Target")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.target,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "target", $$v)
          },
          expression: "model.target"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }